import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Enso } from "../components/SacredGeometry";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const from = location.state?.from || "/dashboard";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome home. The sanctuary is open to you.");
      navigate(from);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 pt-20">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1506126613408-eca07ce68773?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-r from-sanctuary-deep/60 to-sanctuary-deep" />
        <div className="absolute bottom-16 left-12 max-w-sm">
          <div className="font-jp text-gold text-3xl mb-3">おかえり</div>
          <p className="font-display text-3xl text-parchment italic">"Reiki flows where attention rests."</p>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-16 bg-sanctuary-deep">
        <div className="w-full max-w-md">
          <Enso className="w-12 h-12 text-gold mb-8" />
          <div className="eyebrow mb-3">Return to your practice</div>
          <h1 className="font-display text-4xl text-parchment font-light mb-10">Enter the Sanctuary</h1>
          <form onSubmit={submit} className="flex flex-col gap-5" data-testid="login-form">
            <div>
              <label className="text-sm text-text-muted mb-2 block">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-sanctuary-card gold-border rounded-lg px-4 py-3 text-parchment focus:border-gold/50 outline-none transition-colors" data-testid="login-email-input" />
            </div>
            <div>
              <label className="text-sm text-text-muted mb-2 block">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-sanctuary-card gold-border rounded-lg px-4 py-3 text-parchment focus:border-gold/50 outline-none transition-colors" data-testid="login-password-input" />
            </div>
            <button type="submit" disabled={loading}
              className="mt-2 py-3 rounded-full bg-gold text-sanctuary-deep font-medium hover:bg-gold-hover transition-colors disabled:opacity-60" data-testid="login-submit-button">
              {loading ? "Opening the door…" : "Enter"}
            </button>
          </form>
          <p className="mt-8 text-sm text-text-muted">
            New to the path?{" "}
            <Link to="/register" className="text-gold link-underline" data-testid="login-to-register">Begin your journey</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
